import { combineReducers } from "@reduxjs/toolkit";

import globalReducer from "./slices/global";

export default combineReducers({
  global: globalReducer
});
